export const MOBILE_PHONE_TEST_ID = {
  continueButton: 'continue-button',
  phoneNumberInput: 'phone-number-input',
};
